<template>
  <div>
    <b-card>
      <b-tabs>
        <b-tab title="Instituição">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="name"
                    placeholder="Nome"
                    v-model="form.name"
                  />
                  <label for="name">Nome</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Origem</label>
                  <b-form-group label="Origem" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.origin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="origins"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="country-list">País</label>
                  <b-form-group label="País" label-for="country-list">
                  <v-select
                    id="country-list"
                    v-model="form.country"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="countries"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="active"
                    name="active"
                    v-model="form.active"
                  >
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
        <b-tab title="Contatos">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="salesEmail"
                    placeholder="Email Comercial"
                    v-model="form.salesEmail"
                  />
                  <label for="salesEmail">Email Comercial</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="supportEmail"
                    placeholder="Email Atendimento"
                    v-model="form.supportEmail"
                  />
                  <label for="supportEmail">Email Atendimento</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="relationshipEmail"
                    placeholder="Email Relacionamento"
                    v-model="form.relationshipEmail"
                  />
                  <label for="relationshipEmail">Email Relacionamento</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="marketingEmail"
                    placeholder="Email Marketing"
                    v-model="form.marketingEmail"
                  />
                  <label for="marketingEmail">Email Marketing</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="salesPhone"
                    placeholder="Telefone Comercial"
                    v-model="form.salesPhone"
                  />
                  <label for="salesPhone">Telefone Comercial</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="supportPhone"
                    placeholder="Telefone Atendimento"
                    v-model="form.supportPhone"
                  />
                  <label for="supportPhone">Telefone Atendimento</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="generalPhone"
                    placeholder="Telefone Geral"
                    v-model="form.generalPhone"
                  />
                  <label for="generalPhone">Telefone Geral</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="marketingPhone"
                    placeholder="Telefone Marketing"
                    v-model="form.marketingPhone"
                  />
                  <label for="marketingPhone">Telefone Marketing</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="whatsappSales"
                    placeholder="WhatsApp Comercial"
                    v-model="form.whatsappSales"
                  />
                  <label for="whatsappSales">WhatsApp Comercial</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="whatsappSupport"
                    placeholder="WhatsApp Atendimento"
                    v-model="form.whatsappSupport"
                  />
                  <label for="whatsappSupport">WhatsApp Atendimento</label>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
        <b-tab title="Endereço">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <b-col md="8">
                <div class="form-label-group">
                  <b-form-input
                    id="addressStreet"
                    placeholder="Logradouro"
                    v-model="form.addressStreet"
                  />
                  <label for="addressStreet">Logradouro</label>
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-label-group">
                  <b-form-input
                    id="addressNumber"
                    placeholder="Número"
                    v-model="form.addressNumber"
                  />
                  <label for="addressNumber">Número</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="addressNeighborhood"
                    placeholder="Bairro"
                    v-model="form.addressNeighborhood"
                  />
                  <label for="addressNeighborhood">Bairro</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="addressCity"
                    placeholder="Cidade"
                    v-model="form.addressCity"
                  />
                  <label for="addressCity">Cidade</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="addressState"
                    placeholder="UF"
                    v-model="form.addressState"
                  />
                  <label for="addressState">UF</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="addressZip"
                    placeholder="CEP"
                    v-model="form.addressZip"
                  />
                  <label for="addressZip">CEP</label>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
      <b-row class="mt-2">
        <b-col>
          <b-button
            type="submit"
            variant="primary"
            class="mr-1"
            @click="onSubmit"
          >
            Enviar
          </b-button>
          <b-button variant="danger" class="mr-1" @click="onBackPage">
            Voltar
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
} from "bootstrap-vue";
import institutionService from "@/providers/institutionService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import AppConstants from '@/appConstants';
import vSelect from "vue-select";

export default {
  props: {},
  data() {
    return {
      dataID: null,
      origins: [],
      countries: [],
      form: {
        _id: "",
        name: "",
        origin: null,
        country: null,
        active: true,
        salesEmail: "",
        supportEmail: "",
        relationshipEmail: "",
        marketingEmail: "",
        salesPhone: "",
        supportPhone: "",
        generalPhone: "",
        marketingPhone: "",
        whatsappSales: "",
        whatsappSupport: "",
        addressStreet: "",
        addressNumber: "",
        addressNeighborhood: "",
        addressCity: "",
        addressState: "",
        addressZip: "",
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Nova Instituição');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
    }
    this.loadDropdowns();
  },
  watch: {
    "form.name"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Nova Instituição');
      }
    }
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_INSTITUTION);
    },
    onSubmit() {
      institutionService
        .registerInstitution(this.form, new URLSearchParams())
        .then(() => {
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getInstitutionDetail() {
      const params = new URLSearchParams();
      institutionService
        .getInstitutionDetails(this.dataID, params)
        .then((res) => {
          this.form._id = res._id;
          this.form.name = res.name;
          this.form.origin = res.origin ? { _id: res.origin._id, name: res.origin.name } : null;
          // this.form.country = res.country ? { _id: res.country._id, namePtBr: res.country.namePtBr } : null;
          this.form.country = res.country;
          this.form.active = res.active;
          this.form.salesEmail = res.salesEmail;
          this.form.supportEmail = res.supportEmail;
          this.form.relationshipEmail = res.relationshipEmail;
          this.form.marketingEmail = res.marketingEmail;
          this.form.salesPhone = res.salesPhone;
          this.form.supportPhone = res.supportPhone;
          this.form.generalPhone = res.generalPhone;
          this.form.marketingPhone = res.marketingPhone;
          this.form.whatsappSales = res.whatsappSales;
          this.form.whatsappSupport = res.whatsappSupport;
          this.form.addressStreet = res.addressStreet;
          this.form.addressNumber = res.addressNumber;
          this.form.addressNeighborhood = res.addressNeighborhood;
          this.form.addressCity = res.addressCity;
          this.form.addressState = res.addressState;
          this.form.addressZip = res.addressZip;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadDropdowns() {
      dropdownService
        .getAllOrigin(new URLSearchParams())
        .then((res) => {
          this.origins = res;
        })
        .catch((err) => console.log(err));

      dropdownService
        .getAllCountries(new URLSearchParams())
        .then((res) => {
          this.countries = res;
          if (this.isUpdate) {
            this.getInstitutionDetail();
          }
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    vSelect,
  },
};
</script>

<style lang="scss">
.subject-badge-select {
  margin-bottom: 10px;
  .badge {
    margin: 0px 5px;
  }
}
</style>
